import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { ExpenseItem } from './po-line-item.model'
import { PoCommonFieldsComponent } from './po-common-fields.component'

@Component({
    selector: 'app-expense-form',
    templateUrl: './expense-form.component.html',
    standalone: true,
    imports: [FormsModule, PoCommonFieldsComponent],
})
export class ExpenseFormComponent {
    item = input.required<ExpenseItem>()
}
